<template>
    <svg
    class="svgEdit"
        @click="clicked"
            @mouseout="mouseover"
            @mouseleave="mouseleave"
            @mouseenter="mouseenter"
            @mousedown="mousedown"
            width="18" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.986 1C6.85461 1 3.64247 2.81238 1.11374 6.43714C1.04156 6.54174 1.00201 6.66539 1.00007 6.79246C0.998143 6.91954 1.03392 7.04433 1.10289 7.15108C3.04584 10.1925 6.215 12.5709 9.986 12.5709C13.716 12.5709 16.9503 10.1852 18.8968 7.13702C18.9642 7.03236 19 6.91053 19 6.78607C19 6.66161 18.9642 6.53978 18.8968 6.43513C16.9458 3.42186 13.6879 1 9.986 1Z" stroke="black" stroke-linecap="round"/>
        <path d="M9.99955 9.99962C11.7747 9.99962 13.2137 8.5606 13.2137 6.78547C13.2137 5.01034 11.7747 3.57132 9.99955 3.57132C8.22442 3.57132 6.7854 5.01034 6.7854 6.78547C6.7854 8.5606 8.22442 9.99962 9.99955 9.99962Z" stroke="black" stroke-miterlimit="10" stroke-linecap="round" />
    </svg>
</template>
<script>
export default {
    props:["color"],
    methods: {
        clicked() {
            this.$emit('clicked')
        },
        mouseover() {
            this.$emit('mouseover')
        },
        mouseleave() {
            this.$emit('mouseleave')
        },
        mousedown() {
            this.$emit('mousedown')
        },
        mouseenter() {
            this.$emit('mouseenter')
        },
    }
}
</script>
<style>
.svgEdit:hover path {
    stroke:#EF2035;
    stroke-width:2;
}
.svgEdit:hover circle {
    stroke:#EF2035;
    stroke-width:6;
    cursor:pointer;
}
</style>